export const validateVendorForm = ({ name, lastName, businessName }: { name: string; lastName: string;  businessName: string }) => {
  const errors = {
    name: "",
    lastName: "", // Add lastName validation
    businessName: ""
  };

  if (!name) {
    errors.name = "First name is required";
  }

  if (!lastName) {
    errors.lastName = "Last name is required";
  }

  if (!businessName) {
    errors.businessName = "Bussiness name is required";
  }

  // Check if any error messages are present
  const hasErrors = Object.values(errors).some((error) => error !== "");

  return { hasErrors, errors };
};
